export const validationMessages = {
  emailNotValid: "The email is not valid",
  max30chars: "The value must be no more than 30 characters",
  notValid: "The field is not valid",
  required: "The field is required"
}